import { Col, Row } from 'react-bootstrap';
import { Breadcrumb } from '../../../components/Breadcrumb';
import { Report } from '../../../components/Report';

export const ReportCampaign = () => (
  <div>
    <Breadcrumb
      items={[
        {
          title: 'Campanhas',
          link: '/campaign',
        },
        {
          title: 'Relatório',
        },
      ]}
    />

    <Row className="d-flex align-items-center mt-4">
      <Col md={10} xs={8}>
        <h4>Relatório da campanha</h4>
      </Col>
    </Row>

    <Report route="campaigns" />
  </div>
);
